const MAIN_SET_APP_INITIALIZED = "MAIN_SET_APP_INITIALIZED"

const mainTypes = {
    MAIN_SET_APP_INITIALIZED
}

export default mainTypes